// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
// import * as Yup from "yup";
import {
  Input,
  Select,
  // DatePickerField,
} from "../../../../../../_metronic/_partials/controls";

// Validation schema


export function CustomerEditForm({
  saveCustomer,
  customer,
  actionsLoading,
  onHide,
  areas,
}) {
  console.log(customer,'customer');
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={customer}
        // validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          saveCustomer(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  <div className="col-lg-4">
                    <Select name="neighborhood" label="Areas">
                      <option value="">Select area</option>  
                      {areas && areas.map(d => <option value={d._id} selected={d._id === customer?.neighborhood ? true : false}>{d.area}</option>)}
                     </Select>
                  </div>
                  <div className="col-lg-8">
                    <Field
                      name="title"
                      component={Input}
                      placeholder="Question"
                      label="Question"
                    />
                  </div>
                  </div>
                  <div className="form-group row">
                  {/* Last Name */}
                  <div className="col-lg-4">
                    <Field
                      name="option1"
                      component={Input}
                      placeholder="option 1"
                      label="option 1"
                    />
                  </div>
                  <div className="col-lg-4">
                    <Field
                      name="option2"
                      component={Input}
                      placeholder="option 2"
                      label="option 2"
                    />
                  </div>
                  <div className="col-lg-4">
                    <Field
                      name="option3"
                      component={Input}
                      placeholder="option 3"
                      label="option 3"
                    />
                  </div>
                  </div>
                  <div className="form-group row">
                     <div className="col-lg-4">
                    <Field
                      name="correctOption"
                      component={Input}
                      placeholder="Correct Option"
                      label="Correct Option"
                    />
                  </div>
                  <div className="col-lg-8">
                    </div>
                 
                </div>
               
                 
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="submit"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
              >
                Save
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
